import { FC, SVGProps } from 'react';
import { FacebookIcon, TwitterIcon, LinkedinIcon } from '../../../../../public/assets/icons';
import config from '@/shared/config';

export const footer_left_menus: { label: string; href: string }[] = [
   { href: `${config.WP_URL}/about`, label: 'About' },
   { href: `${config.WP_URL}/faq`, label: 'FAQ' },
   { href: `/clinics`, label: 'Clinic Directory' },
   { href: `${config.WP_URL}/police-guidance/`, label: 'Police Guidance' },
   { href: `${config.WP_URL}/cancard-aware`, label: 'Cancard Aware' },
];

export const footer_right_menus: { label: string; href: string }[] = [
   { href: `${config.WP_URL}/news`, label: 'News' },
   { href: `${config.WP_URL}/resources`, label: 'Resources' },
   { href: `${config.WP_URL}/contact`, label: 'Contact Us' },
   { href: `${config.WP_URL}/terms-conditions`, label: 'Terms & Conditions' },
   { href: `${config.WP_URL}/privacy`, label: 'Privacy' },
];

export const social_icons: { icon: FC<SVGProps<SVGSVGElement>>; href: string }[] = [
   { icon: FacebookIcon, href: 'https://www.facebook.com/' },
   { icon: TwitterIcon, href: 'https://www.twitter.com/' },
   { icon: LinkedinIcon, href: 'https://www.linkedin.com/' },
];
